if (!customElements.get('background-video')) {
  class BackgroundVideo extends HTMLElement {
    constructor() {
      super();
      this.playing = false;

      this.container = this.closest('.background-video-container');
      this.contentContainer = this.querySelector('.background-video__content-container');
      this.videoElement = this.querySelector('video');
    }

    connectedCallback() {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.play();
          } else {
            this.stop();
          }
        });
      }, {
        threshold: 0.4,
      });
      
      observer.observe(this.videoElement);
    }

    play() {
      if (this.playing) {
        return;
      }

      this.playing = true;
      this.videoElement.play();
      this.contentContainer.classList.add('background-video__content-container--is-visible');
    }

    stop() {
      this.playing = false;
    }
  }

  customElements.define('background-video', BackgroundVideo);
}
